
import { Component, Inject, Vue } from 'vue-property-decorator';
import PageName from '../../core/components/PageName.vue';
import LoadingIndicator from '../../core/components/Generics/LoadingIndicator.vue';
import Button from '../../core/components/Generics/Button.vue';
import ItemIndicators from '../item/components/ItemIndicators.vue';
import ClaimsAccordion from './components/ClaimsAccordion.vue';
import { ColorsList } from '../../core/utils/type-colors';
import { ItemClaimsPort, ItemWithClaimsResponse } from '../../core/api/ports';
import { InjectionKey } from '../../core/injection-keys';
import { IndicatorConfig, TenantConfig } from '../../tenants/types';

/**
 * Item con la lista de sus siniestros en acordeón (`RouteKey.ItemClaims`, `/item/claims/:id/:token`).
 * El token ya lo fijó `UrlTokenStrategy`; el backend resuelve el item a partir de él.
 */
@Component({
    components: {
        PageName,
        LoadingIndicator,
        Button,
        ItemIndicators,
        ClaimsAccordion
    }
})
export default class PageItemClaims extends Vue {
    @Inject(InjectionKey.Tenant) readonly tenant!: TenantConfig;
    @Inject(InjectionKey.ItemClaimsApi) readonly itemClaimsApi!: ItemClaimsPort;
    pendingInfo: boolean = false;
    errorDetail: boolean = false;
    detailInfo: ItemWithClaimsResponse | null = null;
    orangeColor: string = ColorsList.mid_orange;

    get itemIndicators(): IndicatorConfig[] {
        return this.tenant.pages.itemClaims ? this.tenant.pages.itemClaims.indicators : [];
    }

    created(){
        this.getItemInfo()
    }

    closeItem(){
        let self = this;
        if(window.confirm('¿Desea salir del Item?')) {
            if(this.detailInfo && this.detailInfo.redirect_url){
                let haveUrl = this.detailInfo && this.detailInfo.redirect_url !== '';
                let redirectUrl = this.detailInfo.redirect_url;
                if(haveUrl) {
                    setTimeout(() => {
                        window.location.href = redirectUrl;
                    }, 800);
                }

                setTimeout(() => {
                    window.open('', '_self'); 
                    window.close();     
                }, 500);
            }
        }
    }

    getItemInfo(){
        this.errorDetail = false;
        this.pendingInfo = true;
        this.itemClaimsApi.getItemWithClaims().then((response: ItemWithClaimsResponse) => {
            this.detailInfo = response;
        }).catch((error) => {
        this.errorDetail = true
        this.detailInfo = null 
        }).finally(() => {
            this.pendingInfo = false
            
        })
    }
}
